import type { ChipProps, FormControlLabelProps, Palette, PaletteColor } from '@mui/material';
import { Checkbox, Chip, FormControlLabel, Radio, Switch, Typography, chipClasses, styled } from '@mui/material';

export type LookoSwitchType = {
  disabled?: boolean;
  label?: React.ReactNode;
  checked?: FormControlLabelProps['checked'];
  onChange?: FormControlLabelProps['onChange'];
};
/**
 * 스위치.
 *
 * ```tsx
 * // 라벨 있음
 * <LookoSwitch label="활성화" checked={isOn} onChange={handleChange} />
 * // 라벨 없음
 * <LookoSwitch checked={isOn} onChange={handleChange} />
 * ```
 */
export const LookoSwitch = styled((props: LookoSwitchType) => {
  return <FormControlLabel label={''} {...props} control={<Switch size="medium" />} sx={{ margin: 0 }} />;
})(({ theme }) => {
  return {
    '& .MuiTypography-root': { fontSize: 14, fontWeight: '400' },
    p: 0,
  };
});
